import { style } from 'typestyle'
export const mt40 = style({ marginTop: '40px' })
